class NewPdpHero {
  constructor(el) {
    this.el = el;
    this.count = parseInt(el.dataset.imagesCount, 10) || 1;
    this.emblaNode = el.querySelector('[data-hero-embla]');
    this.mobileDots = el.querySelectorAll('[data-hero-dot]');
    this.desktopDots = el.querySelectorAll('[data-hero-dot-desktop]');
    this.mobileTop = el.querySelector('[data-hero-mobile-top]');

    if (!this.emblaNode) return;

    this.api = EmblaCarousel(this.emblaNode, {
      loop: true,
      dragFree: false,
    });

    if (this.count > 1) {
      this.api.on('select', () => this.updateDots());
      this.api.on('select', () => this.updateMobileTop());

      this.mobileDots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.api.scrollTo(i));
      });

      this.desktopDots.forEach((dot, i) => {
        dot.addEventListener('click', () => this.api.scrollTo(i));
      });
    }
  }

  updateDots() {
    const index = this.api.selectedScrollSnap();
    this.mobileDots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
    this.desktopDots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  updateMobileTop() {
    if (!this.mobileTop) return;
    const onFirst = this.api.selectedScrollSnap() === 0;
    this.mobileTop.classList.toggle('is-hidden', !onFirst);
  }

}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-new-pdp-hero]')
    .forEach((el) => new NewPdpHero(el));
});
